import React, { createContext, useContext, useState } from "react";

const FlashMessageContext = createContext();

export const FlashMessageProvider = ({ children }) => {
  const [flashMessage, setFlashMessage] = useState(null);

    const showMessage = ({severity, title, message}) => {
    setFlashMessage({ severity, title, message });
    setTimeout(() => setFlashMessage(null), 5000); // Auto-clear after 5 seconds
  };

  return (
    <FlashMessageContext.Provider value={{ flashMessage, showMessage }}>
      {children}
    </FlashMessageContext.Provider>
  );
};

export const useFlashMessage = () => useContext(FlashMessageContext);
